module.exports = __webpack_public_path__ + "img/checker.954a5380.svg";